import {createReducer, on} from '@ngrx/store';
import {EAccountConfirmationStatus, ELoginStatus, IAuthState} from '../models/auth-state.model';
import {
  accountConfirmationFailure,
  accountConfirmationSuccess,
  authenticate,
  authenticateFailure,
  authenticateSuccess,
  changePasswordFailure,
  changePasswordSuccess,
  forgotPasswordFailure,
  forgotPasswordSuccess,
  resetChangePasswordStatus,
  resetPasswordFailure,
  resetPasswordStateReset,
  resetPasswordSuccess,
} from './auth.actions';

const initialState: IAuthState = {
  status: ELoginStatus.Initial,
  token: '',
  accountConfirmationStatus: EAccountConfirmationStatus.Pending,
  resetPasswordStatus: EAccountConfirmationStatus.Pending,
  forgotPasswordStatus: EAccountConfirmationStatus.Pending,
  changePasswordStatus: EAccountConfirmationStatus.Pending,
  errorMessage: '',
};

export const authReducer = createReducer(
  initialState,
  on(authenticateSuccess, (state, {token, status}) => ({
    ...state,
    status,
    token,
  })),
  on(authenticate, state => ({
    ...state,
    status: ELoginStatus.Pending,
  })),
  on(authenticateFailure, state => ({
    ...state,
    status: ELoginStatus.Failed,
  })),
  on(accountConfirmationSuccess, (state, {accountConfirmationStatus}) => ({
    ...state,
    accountConfirmationStatus: accountConfirmationStatus,
  })),
  on(accountConfirmationFailure, (state, {accountConfirmationStatus}) => ({
    ...state,
    accountConfirmationStatus: accountConfirmationStatus,
  })),
  on(resetPasswordSuccess, (state, {resetPasswordStatus}) => ({
    ...state,
    resetPasswordStatus: resetPasswordStatus,
  })),
  on(resetPasswordFailure, (state, {resetPasswordStatus}) => ({
    ...state,
    resetPasswordStatus: resetPasswordStatus,
  })),
  on(resetPasswordStateReset, state => ({
    ...state,
    resetPasswordStatus: EAccountConfirmationStatus.Pending,
  })),
  on(forgotPasswordSuccess, (state, {forgotPasswordStatus}) => ({
    ...state,
    forgotPasswordStatus: forgotPasswordStatus,
  })),
  on(forgotPasswordFailure, (state, {forgotPasswordStatus}) => ({
    ...state,
    forgotPasswordStatus: forgotPasswordStatus,
  })),
  on(changePasswordSuccess, (state, {changePasswordStatus}) => ({
    ...state,
    changePasswordStatus: changePasswordStatus,
    errorMessage: '',
  })),
  on(changePasswordFailure, (state, {changePasswordStatus, errorMessage}) => ({
    ...state,
    changePasswordStatus: changePasswordStatus,
    errorMessage: errorMessage,
  })),
  on(resetChangePasswordStatus, state => ({
    ...state,
    changePasswordStatus: EAccountConfirmationStatus.Pending,
  }))
);
